/**
 * Module d'offres spéciales - Mapping projectId vers contenu HTML
 *
 * Pour ajouter une nouvelle offre spéciale :
 * 1. Créer un fichier HTML dans src/special-offers/offers/{nom}.html
 * 2. Importer le fichier avec ?raw et l'ajouter au mapping ci-dessous
 */
import arkoliaHtml from './offers/arkolia.html?raw';

// Mapping projectId vers contenu HTML
const specialOffers: Record<string, string> = {
  'ARKOLIA-2025-001': arkoliaHtml,
};

/**
 * Récupère le contenu HTML de l'offre spéciale pour un projet donné
 */
export function getSpecialOfferContent(projectId: string): string | null {
  return specialOffers[projectId] || null;
}

/**
 * Vérifie si un projet a une offre spéciale configurée
 */
export function hasSpecialOffer(projectId: string): boolean {
  return projectId in specialOffers;
}

export default specialOffers;
